import React from 'react';

const Footer = () => (
  	<div id="footer">
        <a id="acks-btn" href="documents/acknowledgments.pdf" target="_blank"></a>
        <div id="copyright"></div>
        <div id="footer-logo"></div>
    </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/global/Footer.js